import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { TreatmentWarning } from 'it/primatoo/openapi/api/org/schemas/treatment/TreatmentWarning';

@Component({
  selector: 'pt-editor-notification',
  template: `
    <div class="w-100" style="min-height: 24px">
      <div *ngIf="noChapterPermission" class="message">
        {{'MESSAGE.MISSING_WRITE_PERMISSION' | translate}}
      </div>
      <ng-container *ngIf="!noChapterPermission">
        <div *ngIf="message && !wait" class="message" [innerHTML]="message"></div>
      </ng-container>

      <div *ngIf="autosave" class="autosave" [innerHTML]="'TITLE.AUTOSAVE' | translate"></div>

      <div *ngIf="userCheck" class="position-relative w-100">
        <div class="message" [innerHTML]="'MESSAGE.USER_CHECK_REQUIRED' | translate"></div>
        <button type='button' class='btn-close pt-editor-notification-btn-close-custom' aria-label='Close'
                (click)='removeUserCheck.emit(); userCheck = false;'>
        </button>
      </div>

      <ng-container *ngFor="let w of warnings">
        <div *ngIf="w === TW.APP_LIST_CHANGED" class="message" [innerHTML]="'MESSAGE.APP_LIST_CHANGED' | translate"></div>
        <div *ngIf="w === TW.GLOBAL_MEAS_ANSWER_CHANGED" class="message" [innerHTML]="'MESSAGE.GLOBAL_MEAS_ANSWER_CHANGED' | translate"></div>
        <div *ngIf="w === TW.GLOBAL_MEAS_LIST_CHANGED" class="message" [innerHTML]="'MESSAGE.GLOBAL_MEAS_LIST_CHANGED' | translate"></div>
        <div *ngIf="w === TW.RID_CHANGED" class="message" [innerHTML]="'MESSAGE.RID_CHANGED' | translate"></div>
        <div *ngIf="w === TW.LI_SELECTED" class="message" [innerHTML]="'MESSAGE.LI_SELECTED' | translate"></div>
      </ng-container>
    </div>
  `,
  styles: [
    `
      .pt-editor-notification-btn-close-custom {
        position: absolute;
        top: 11px;
        right: 26px;
        font-size: 10px;
      }

      .btn-close-custom:hover {
        font-weight: bold;
        cursor: pointer;
      }

      .message {
        background: #ffc107ad;
        font-weight: 100;
        text-align: center;
        font-size: 13px;
        color: #140e0e;
        margin: 0 2px 2px 2px;
        width: calc(100% - 6px);
      }

      .autosave {
        font-weight: bold;
        text-align: center;
        font-size: 13px;
        color: white;
        margin: 0 2px 2px 2px;
        width: calc(100% - 6px);
        background: var(--bs-success);
      }
    `
  ]
})
export class EditorNotificationComponent implements OnChanges {

  @Input() noChapterPermission = false;
  @Input() userCheck = false;
  @Input() autosave: boolean;
  @Input() message: string;
  @Input() warnings: Array<TreatmentWarning> = [];


  @Output() removeUserCheck = new EventEmitter();
  public wait = true;
  private timeout: any;
  TW = TreatmentWarning;
  ngOnChanges(changes: SimpleChanges): void {
    this.wait = true;
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(() => this.wait = false, 500);

  }
}
